import type { MutableRefObject } from 'react';
import { useEffect, useRef } from 'react';

/**
 * Use this hook to determine if a component is mounted or not. This returns a ref that will be true
 * if the component is mounted and false if it is not.
 * IsMounted will be true for the first render.
 */
export const useIsMounted = (): MutableRefObject<boolean> => {
    // use a default of true, so it's true for the first render
    const isMounted = useRef(true);

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    return isMounted;
};
